<td class="text-end">{{label | translate}}:</td>
<td>
  <ng-content></ng-content>
</td>
